import * as React from 'react';
import DropdownTreeSelect, { TreeNode } from 'react-dropdown-tree-select';
import 'react-dropdown-tree-select/dist/styles.css';
import { Box, Typography } from '@material-ui/core';
import { useStyles } from '../../../custom-forms';
import { OrganizationBranch } from '../../../interfaces/Case';
import { useTranslate } from '../../../hooks/useTranslate';

export interface AlternativeCalculationDeliveryAddressProps {
  addresses: OrganizationBranch[];
  onChange: (currentNode: TreeNode, selectedNodes: TreeNode[]) => void;
}

const AlternativeCalculationDeliveryAddress: React.FC<
  AlternativeCalculationDeliveryAddressProps
> = ({ addresses, onChange }) => {
  const c = useStyles();
  const t = useTranslate();
  return (
    // Teal custom radio comes from the global .react-dropdown-tree-select rules in custom.css.
    <Box style={{ minWidth: 260 }}>
      <Typography variant="caption" display="block" className={c.faint}>
        {t('CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_LOCATION_TEXT', 'Adresa de livrare:')}
      </Typography>
      <DropdownTreeSelect
        data={addresses}
        mode="radioSelect"
        onChange={(currentNode, selectedNodes) => onChange(currentNode, selectedNodes)}
        texts={{
          placeholder: t(
            'CASE_CALCULATION_ALTERNATIVE_CALCULATION_DETAILS_CHOOSE_TEXT',
            'Selectează'
          )
        }}
      />
    </Box>
  );
};

export default AlternativeCalculationDeliveryAddress;
